module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_18_A.e31351fc.mp3";